import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'languages';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();
  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  const save = async ({ id, values }) => (id ? update({ id, values }) : create({ values }));

  const getByCode = ({ code }) => dataSource.get(`${BASE_PATHNAME}/code/${code}`).json();
  const getByCodes = ({ codes }) => Promise.all(codes.map((code) => getByCode({ code })));

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
    }),

    getById,

    getByIds,

    remove,

    create,

    update,

    save,

    getByCode,

    getByCodes,

    getEmptyList: getDefaultEmptyList,
  };
};
